import { signal } from '@preact/signals-react'

export const isEmptyDynamicAssortment = signal(false)
